module.exports = __webpack_public_path__ + "img/quest-success.537d8ec9.png";